"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = void 0;
var Theme = exports.Theme = /*#__PURE__*/function (Theme) {
  Theme["DEFAULT"] = "default";
  Theme["QUINTOCRED"] = "quintocred";
  Theme["VERIFICADO"] = "verificado";
  Theme["NOKNOX"] = "noknox";
  Theme["INMUEBLES24"] = "inmuebles24";
  return Theme;
}(Theme || {});